import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import update from 'immutability-helper';

import './RSVPAdmin.css';

const mapStateToProps = state => ({
  activeStyle: state.styles.activeStyle,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const eventNames = {
  ca: 'Preception',
  ny: 'Wedding',
  ba: 'Bachelor Party',
};

function getRSVPs() {
  const url = process.env.REACT_APP_API_URL;

  return fetch(`${url}/events/rsvps`).then(response => response.json());
}

const RSVPList = ({ data, toggle }) => {
  const items = Object.entries(data).map(([key, val]) => {
    const attendees = val.attendees.map((x, i) => <div key={key + i}>{x}</div>);
    return (
      <div key={key}>
        <h2 className="rsvp-event-name">{eventNames[key]}</h2>
        <div>Invited: {val.inviteeCount}</div>
        <div>Attending: {val.attendeeCount}</div>
        {val.showAttendees ? (
          <div className="rsvp-show-attendees" onClick={() => toggle(key)}>
            Hide Attendees
          </div>
        ) : (
          <div className="rsvp-show-attendees" onClick={() => toggle(key)}>
            Show Attendees
          </div>
        )}
        {val.showAttendees ? <div>{attendees}</div> : null}
      </div>
    );
  });
  return <div className="rsvp-parent-list">{items}</div>;
};

class RSVPAdmin extends Component {
  defaultData = {
    inviteeCount: 0,
    attendeeCount: 0,
    attendees: [],
    showAttendees: false,
  };
  state = {
    data: { ny: this.defaultData, ca: this.defaultData, ba: this.defaultData },
  };

  toggleShowAttendees(event) {
    const originalValue = this.state.data[event].showAttendees;
    const newState = update(this.state, {
      data: {
        [event]: {
          showAttendees: { $set: !originalValue },
        },
      },
    });
    this.setState(newState);
  }

  async componentWillMount() {
    const data = await getRSVPs();
    for (const d of Object.keys(data)) {
      data[d].showAttendees = false;
    }
    this.setState({
      data,
    });
  }

  render() {
    return (
      <section
        id="rsvp-admin-section"
        className={`custom-style-${this.props.activeStyle}`}
      >
        <RSVPList
          {...this.state}
          toggle={this.toggleShowAttendees.bind(this)}
        />
      </section>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RSVPAdmin);



// WEBPACK FOOTER //
// ./src/components/RSVPAdmin.js